import { render, staticRenderFns } from "./Seguranca.vue?vue&type=template&id=4da76309"
import script from "./Seguranca.vue?vue&type=script&lang=ts"
export * from "./Seguranca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports